import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

const SocialAndEnvironmentalEffect: FC = () => {
  return <Outlet />;
};

export default SocialAndEnvironmentalEffect;
